import { render } from "./DevelopmentHome.vue?vue&type=template&id=68787de6"
import script from "./DevelopmentHome.vue?vue&type=script&lang=js"
export * from "./DevelopmentHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__